import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  const { t, lp } = useLang();
  useSeo("notFound");
  return (
    <section className="flex min-h-[70vh] items-center bg-[#0F2138] pt-24" data-testid="not-found">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <h1 className="font-serif text-5xl text-white">{t.notFound.title}</h1>
        <Link to={lp("/")} className="btn-brass mt-8" data-testid="not-found-home">{t.notFound.back}</Link>
      </div>
    </section>
  );
}
